import { Alert, Dialog, Stack, Typography } from '@all-manager/design-system-v2';
import type { SubjectHistoryFeed } from '../../../../types';
import SubTopicAutocomplete from '../../external-components/SubTopicAutocomplete/SubTopicAutocomplete';
import { useMoveHistoryItemModal } from './useMoveHistoryItemModal';

type Props = {
  item: SubjectHistoryFeed;
  onClose: () => void;
};

export default function MoveHistoryItemModal(props: Props) {
  const hook = useMoveHistoryItemModal(props);

  return (
    <Dialog
      open
      onClose={hook.handleClose}
      maxWidth="sm"
      fullWidth
      title="Déplacer vers un autre sous-sujet"
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: 'Déplacer',
          onClick: hook.handleConfirm,
          loading: hook.isPending,
          disabled: !hook.targetId,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: hook.handleClose,
          disabled: hook.isPending,
        },
      }}
    >
      <Stack spacing={2}>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}

        <Typography variant="body1">
          L&apos;élément quittera ce sous-sujet et apparaîtra dans l&apos;historique du sous-sujet choisi.
        </Typography>

        <SubTopicAutocomplete
          label="Sous-sujet de destination"
          value={hook.targetId}
          onChange={hook.setTargetId}
          excludeIds={props.item.subject_id ? [props.item.subject_id] : []}
          fullWidth
          required
          autoFocus
        />
      </Stack>
    </Dialog>
  );
}
